import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CATEGORY_CARD_NAME = 'CategoryCard';
export const CATEGORY_CARD_SLOTS: Array<keyof CategoryCardClasses> = [
	'root',
	'actionBox',
	'imageContainer',
	'description',
	'titleBox',
	'svgIcon',
] as const;

export type CategoryCardSlot = (typeof CATEGORY_CARD_SLOTS)[number];

export interface CategoryCardClasses {
	root: string;
	actionBox: string;
	imageContainer: string;
	description: string;
	titleBox: string;
	svgIcon: string;
	hasDescription: string;
	hasImage: string;
}

export type CategoryCardClassKey = keyof CategoryCardClasses;

export const getCategoryCardUtilityClass = (slot: string) =>
	generateUtilityClass(CATEGORY_CARD_NAME, slot as CategoryCardSlot);

export const categoryCardClasses: CategoryCardClasses = generateUtilityClasses(
	CATEGORY_CARD_NAME,
	[
		'root',
		'actionBox',
		'imageContainer',
		'description',
		'titleBox',
		'svgIcon',
		'hasDescription',
		'hasImage',
	],
);

export default categoryCardClasses;
